const Congratz = () => {
  return (
    <>
      <div className="container">
        <div className="row py-5">
          <div className="col-md-3 col-sm-12"></div>
          <div className="text-center col-md-6 col-sm-12" style={{minHeight:"100vh"}}>
            <h5 className="mb-5 text-dark mt-5">
              Congratulations! Our team will review your application and get
              back to you!
            </h5>
          </div>
          <div className="col-md-3 col-sm-12"></div>
        </div>
      </div>
    </>
  );
};

export default Congratz;
